import React, { useEffect, useState } from 'react';
import { Link, Outlet,useLocation  } from 'react-router-dom';
import {
    Navbar,
    Collapse,
    Nav,
    NavItem,
    Button,
    Container,
    Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faDashboard, faDownload, faList, faBars, faTimes, faGlobe, faChevronLeft, faChevronRight, faBarsStaggered, faBarsProgress, faUpload, faFileArrowUp, faBell, faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import PropagateLoader from 'react-spinners/PropagateLoader'; // Import only the used loader
import './Home.css';
import BASE_URL, { getUserPrivilege } from '../Services/Employees';
import Header from './../Header/Header';

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [links, setLinks] = useState([]);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const location = useLocation();
    const toggle = () => setIsOpen(!isOpen);
    const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);

    const icons = {
        "Dashboard": faDashboard,
        "Apply Online": faGlobe,
        "Selected Exam": faPaperPlane,
        "Admit Card": faDownload,
        "Result": faList,
        "Upload Allocation": faUpload,
        "Upload Result": faFileArrowUp,
        "Upload Notice": faBell,
        "Event": faCalendarPlus,
        "Report":faFileArrowUp
    };

    const path = {
        
       "/dashboard/employeeDashboard":"Dashboard",
        "/dashboard/centreselect":"Apply Online",
        "/dashboard/selectedexam":"Selected Exam",
       "/dashboard/admitcard":"Admit Card",
        "/dashboard/result":"Result",
       "/dashboard/uploadAllocation":"Upload Allocation",
        "/dashboard/uploadResult":"Upload Result",
        "/dashboard/uploadNotice":"Upload Notice",
        "/dashboard/event":"Event",
    };

    const linkPath = {
        "Dashboard": "/dashboard/employeeDashboard",
        "Apply Online": "/dashboard/centreselect",
        "Selected Exam": "/dashboard/selectedexam",
        "Admit Card": "/dashboard/admitcard",
        "Result": "/dashboard/result",
        "Upload Allocation": "/dashboard/uploadAllocation",
        "Upload Result": "/dashboard/uploadResult",
        "Upload Notice": "/dashboard/uploadNotice",
        "Event": "/dashboard/event",
        "Report": "/dashboard/report"
    };

    useEffect(() => {
        getUserPrivilege().then((response) => {
            const updatedLinks = response.data.map(element => {
                const key = element.key;
                if (linkPath[key]) {
                    return {
                        ...element,
                        to: linkPath[key],
                        icon: icons[key]
                    };
                }
                return element;
            });
            setLinks(updatedLinks);
            setLoading(false); // Stop loading once data is fetched
        })
            .catch(error => {
                console.error("Error fetching user privileges:", error);
                setLoading(false); // Stop loading even if there's an error
            });
    }, []);
    const getPageTitle = () => {
        return path[location.pathname] || "Dashboard";
    };

    return (
        <div className="dashboard-container">
             <Header
                isSidebarCollapsed={isSidebarCollapsed}
                toggleSidebar={toggleSidebar}
                getPageTitle={getPageTitle}
            />
            <Navbar color="light" light expand="md" className="mb-3 d-md-none">
                <Container fluid>
                    <Button color="primary" onClick={toggle}>
                        <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
                    </Button>

                    <Collapse isOpen={isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <Link className="nav-link" to="/dashboard/employeeDashboard" onClick={toggle}>
                                    <FontAwesomeIcon icon={faDashboard} /> Dashboard
                                </Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/dashboard/centreselect" onClick={toggle}>
                                    <FontAwesomeIcon icon={faGlobe} /> Apply Online
                                </Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/dashboard/selectedexam" onClick={toggle}>
                                    <FontAwesomeIcon icon={faPaperPlane} /> Selected Exam
                                </Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/dashboard/admitcard" onClick={toggle}>
                                    <FontAwesomeIcon icon={faDownload} /> Admit Card
                                </Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/dashboard/result" onClick={toggle}>
                                    <FontAwesomeIcon icon={faList} /> Result
                                </Link>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>

            {/* Sidebar for larger screens */}
            <div className={`d-md-flex  ${isOpen ? 'show' : 'hide'}`}>
                <Col md="2" className={`d-none d-md-block sidebar  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    
                    <Nav vertical className="nav-vertical mt-2">
                        {links.map((link, index) => (
                            <NavItem key={index}>
                                <Link className="nav-link" to={link.to}>
                                    <FontAwesomeIcon icon={link.icon} /> &nbsp;&nbsp;
                                    {!isSidebarCollapsed && link.key}
                                </Link>
                            </NavItem>
                        ))}
                    </Nav>
                </Col>

                <Col md={isSidebarCollapsed ? "11" : "10"} className="main-content" style={{backgroundColor:"#f5f5f5"}}>
                <div style={{minHeight:"6%",backgroundColor:"white",marginBottom:"1%",position:"relative"}}>
                {/* <Button onClick={toggleSidebar} className="sidebar-toggle">
                        <FontAwesomeIcon icon={isSidebarCollapsed ?  faBarsStaggered : faBars} />
                    </Button> */}
                    <p className='me-2 py-1 fw-bold text-primary text-end'>Home &nbsp;|&nbsp;{getPageTitle()}</p>
                </div>
                    {loading ? (
                        <div className="loader-container">
                            <PropagateLoader color="#00BFFF" size={30} /> {/* Increase the size here */}
                        </div>
                    ) : (
                        <Outlet />
                    )}
                </Col>
            </div>
        </div>
    );
};

export default Home;
